"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visible && _vm.redditEnabled ? _c('div', {
    staticClass: "kiwi-reddit-drawer-overlay",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c('aside', {
    staticClass: "kiwi-reddit-drawer kiwi-theme-bg",
    attrs: {
      "aria-label": "Reddit del sub"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('header', {
    staticClass: "kiwi-reddit-drawer-header"
  }, [_c('div', {
    staticClass: "kiwi-reddit-drawer-title"
  }, [_c('i', {
    staticClass: "fa fa-reddit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.subTitle))])]), _c('button', {
    staticClass: "kiwi-reddit-drawer-close",
    attrs: {
      "type": "button",
      "title": "Cerrar"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm.isElectron ? _c('div', {
    staticClass: "kiwi-reddit-drawer-oauth"
  }, [_c('p', {
    staticClass: "kiwi-reddit-drawer-oauth-hint"
  }, [_vm._v(" Reddit no tiene SDK oficial: la app se registra en reddit.com/prefs/apps y aquí usas OAuth2 (API oficial). ")]), _c('div', {
    staticClass: "kiwi-reddit-drawer-oauth-row"
  }, [_vm.redditOAuthConnected ? _c('span', {
    staticClass: "kiwi-reddit-oauth-ok"
  }, [_vm._v(" Sesión Reddit: conectada ")]) : _c('span', {
    staticClass: "kiwi-reddit-oauth-off"
  }, [_vm._v(" Sesión: anónima (solo lectura pública) ")])]), !_vm.oauthClientConfigured ? _c('div', {
    staticClass: "kiwi-reddit-drawer-oauth-warn"
  }, [_vm._v(" Configura "), _c('code', [_vm._v("reddit.oauthClientId")]), _vm._v(" y el mismo "), _c('code', [_vm._v("oauthRedirectUri")]), _vm._v(" en la app de Reddit. ")]) : _c('div', {
    staticClass: "kiwi-reddit-drawer-oauth-actions"
  }, [!_vm.redditOAuthConnected ? _c('button', {
    staticClass: "kiwi-reddit-oauth-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.oauthBusy
    },
    on: {
      "click": _vm.startRedditOAuth
    }
  }, [_vm._v(" Conectar con Reddit ")]) : _c('button', {
    staticClass: "kiwi-reddit-oauth-btn kiwi-reddit-oauth-btn--ghost",
    attrs: {
      "type": "button",
      "disabled": _vm.oauthBusy
    },
    on: {
      "click": _vm.logoutRedditOAuth
    }
  }, [_vm._v(" Cerrar sesión Reddit ")])])]) : _vm._e(), _vm.loadError ? _c('div', {
    staticClass: "kiwi-reddit-drawer-error"
  }, [_vm._v(" " + _vm._s(_vm.loadError) + " "), _c('a', {
    staticClass: "u-link",
    attrs: {
      "href": _vm.subredditUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" Abrir en Reddit ")])]) : _vm.loading ? _c('div', {
    staticClass: "kiwi-reddit-drawer-loading"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('ul', {
    staticClass: "kiwi-reddit-drawer-list"
  }, _vm._l(_vm.posts, function (p, idx) {
    return _c('li', {
      key: idx,
      staticClass: "kiwi-reddit-drawer-item"
    }, [_c('button', {
      staticClass: "kiwi-reddit-drawer-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.openPost(p);
        }
      }
    }, [_c('span', {
      staticClass: "kiwi-reddit-drawer-item-title"
    }, [_vm._v(_vm._s(p.title))]), _c('span', {
      staticClass: "kiwi-reddit-drawer-item-meta"
    }, [_vm._v(" ↑ " + _vm._s(p.score) + " · " + _vm._s(p.numComments) + " com. ")])])]);
  }), 0), _c('footer', {
    staticClass: "kiwi-reddit-drawer-footer"
  }, [_c('a', {
    staticClass: "u-link",
    attrs: {
      "href": _vm.subredditUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" Ver r/" + _vm._s(_vm.cleanSub) + " en Reddit ")])])])]) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [];